<template>
  <v-container>
    <v-layout
      wrap
    >
      <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mt-5 ml-5">Mijn Actiepunten</h2>
        <v-divider></v-divider>

        <v-text v-if="alarms.length === 0" class="font-italic">Nog geen actiepunten ontvangen</v-text>
        <v-list justify-center >
          <v-card
                  v-for="(alarm, i) in alarms"
                  :key="i"
                  class="rounded-card"
                  style="border-radius:15px; height:100px"
                  @click="goToAlarm(alarm._id, alarm.type)"
                  outlined
                  color="grey lighten-3"
          >
            <v-row>
              <v-col cols="auto">
                <v-img v-if="alarm.type === 'alert'"
                       :src="images.alert"
                       style="margin-left:9px;"
                       height="73px"
                       width="60px"
                >
                </v-img>
                <v-img v-else-if="alarm.type === 'notification'"
                       :src="images.notification"
                       style="margin-left:9px"
                       height="73px"
                       width="60px"
                >
                </v-img>

                <v-img v-else-if="alarm.type === 'info'"
                       :src="images.info"
                       style="margin-left:9px"
                       height="76px"
                       width="60px"
                >
                </v-img>
              </v-col>
              <v-col cols="auto">
                <v-card-title class="pa-0">
                  {{shorten(alarm.name)}}
                </v-card-title>
                <v-card-description class="body-2">{{convertTimestamp(alarm.timestamp)}}</v-card-description>
                <pre></pre>
                <v-card-description class="body-2">{{getSteps(alarm)}}</v-card-description>
                <pre></pre>
                <v-card-description>{{alarm.action}}</v-card-description>
                <!--<v-card-subtitle>{{alarm.description}}</v-card-subtitle>-->
                <!--<v-card-text class="align-right">{{alarm.timestamp}} uur</v-card-text>-->
              </v-col>
              <v-col>
                <v-img src="./../assets/chevron_right.png" class="justify-end some-icon"></v-img>
              </v-col>

            </v-row>

          </v-card>

<!--          <v-divider></v-divider>-->
<!--          <v-card class="rounded-card text-center"-->
<!--                  style="border-radius:15px; height:100px"-->
<!--                  @click="alternative()"-->
<!--                  outlined-->
<!--                  color="grey lighten-3"><v-card-title>Alternatief design</v-card-title></v-card>-->
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import axios from "axios";
import config from '../config/config.js'

export default {
  data: () => ({
      alarms: [],
      images: {
            alert: require('../assets/alert_workflow.png'),
            notification: require('../assets/notification_workflow.png'),
            info: require('../assets/info_workflow.png')
      }
  }),
  methods: {
      goToAlarm(alarm, type) {
          let temp = alarm;
          //router.push({ path: `/user/${userId}` }) // -> /user/123
          if(type === "alert") {
            this.$router.push({path: 'alarm', query: {uid: temp}});
          } else if(type === "info") {
            this.$router.push({path: 'info', query: {uid: temp}});
          }else if(type === "notification") {
            this.$router.push({path: 'notification', query: {uid: temp}});
          }
          return alarm;
      },
      shorten(string) {
        let short = string.replace(/(.{18})..+/, "$1..");
        return short;
      },
    convertTimestamp(ts) {
      let date = new Date(ts)
      let today = new Date()
      if(date.getDate() < today.getDate()) {
        if (date.getMinutes() < 10 && date.getHours() < 10) {
          return "0" + date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
        } else if(date.getMinutes() < 10) {
          return date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
        } else if(date.getHours() < 10) {
          return "0" + date.getHours()+":" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
        }
        return date.getHours() + ":" + date.getMinutes() + " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
      }
      if (date.getMinutes() < 10 && date.getHours() < 10) {
        return "0" + date.getHours() + ":0" + date.getMinutes()
      } else if(date.getMinutes() < 10) {
        return date.getHours() + ":0" + date.getMinutes()
      } else if(date.getHours() < 10) {
        return "0" + date.getHours()+":" + date.getMinutes()
      }
      return date.getHours() + ":" + date.getMinutes()
    },
    getTimeDifference(ts) {
      let timestamp = new Date(ts)
      let now = new Date()

      let diff = now.getTime() - timestamp.getTime(); // this is a time in milliseconds
      let diff_as_date = new Date(diff);
      diff_as_date.getHours(); // hours
      diff_as_date.getMinutes(); // minutes
      diff_as_date.getSeconds(); // seconds
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds


      const diffDays = Math.round(Math.abs((timestamp - now) / oneDay));
      if(diffDays === 1) {
        return "Gisteren"
      } else if(diffDays === 2) {
        return "2 dagen geleden"
      } else if (diffDays > 2){
        return "Meer dan 2 dagen geleden"
      } else {
        let hours = diff_as_date.getHours()
        let minutes = diff_as_date.getMinutes()
        if(hours !== 0) {
          hours--
        }
        return  hours + " uur en " + minutes + " min. geleden"
      }
    },
      alternative() {
          this.$router.push({path: 'alternative'});
      },
      getSteps(alarm) {
        let max = alarm.workflow.length;
        let finished = 0;
        for(let i = 0; i < max; i++) {
          if(alarm.workflow[i].completed) {
            finished++
          }
        }

        return "Stap " + finished + " van de " + max + "."
      }
    },
    mounted () {
      axios
              .get(config.url +'/alarms')
              .then(response => (this.alarms = response.data.alarms))
      this.$nextTick(function () {
        window.setInterval(() => {
          axios
                  .get(config.url +'/alarms')
                  .then(response => (this.alarms = response.data.alarms))
        },5000);
      })
      window.scrollTo(0,0);
    }
};
</script>

<style scoped lang="css">
  .rounded-card{
    border-radius:50px;
    margin: 5px;
    background: #ffffff;
    border-color: grey;
  }
  v-img {
    padding: 50px;
  }
  .some-icon {
    height: 40px !important;
    width: 40px !important;
    float: right;
    margin-top: 17px;
    margin-right: 2px;
  }
</style>

